import { MobileNavigationHeader } from '@Components//happyFlowTemplate/MobileNavigationHeader.tsx';
import { DesktopSideBar } from '@Components//happyFlowTemplate/desktopSideBar/DesktopSideBar.tsx';
import { PasswordlessDesktopSideBar } from '@Components//happyFlowTemplate/passwordlessDesktopSideBar/passwordlessDesktopSideBar';
import { useBoundStore } from '@Store/index.ts';
import { Outlet } from '@tanstack/react-router';

export const BasicTemplate = () => {
  const isEmbedded = useBoundStore((state) => state.onboardingSlice.getIsEmbedded());
  return (
    <div className='w-full h-full flex flex-col sm:flex-row items-center fade-in'>
      <MobileNavigationHeader />
      {isEmbedded ? <PasswordlessDesktopSideBar /> : <DesktopSideBar />}
      <div className='flex flex-col overflow-hidden h-full   w-full'>
        <div className='h-full w-full overflow-scroll flex  mx-auto no-scrollbar flex-col items-center'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};
